<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="20vh"
    :showClose="false"
  >
    <div class="flex flex-col gap-3 mt-4">
      <h3 class="text-base text-black-10 text-center">Attention</h3>
      <p class="font-semibold text-center text-xs sm:text-sm">
        {{ errorMessage }}
      </p>

      <div class="mx-4">
        <div class="text-center font-normal text-xs md:text-md">
          {{ defaultText }}
        </div>
        <div class="mt-6 sm:mt-8 flex justify-center gap-4 mb-3">
          <button
            @click="requestVerification"
            class="bg-gray-200 text-black-10 py-3 px-5 cursor-pointer"
          >
            Request
          </button>
          <button
            @click="handleClose"
            class="bg-primary text-white py-3 px-5 cursor-pointer"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      defaultText: 'Kindly request for a verification link'
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '60%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    requestVerification () {
      this.defaultText = 'Sending email verification link.......'
      this.$emit('handleResendVerification')
    }
  }
}
</script>

<style scoped>
button {
  border-radius: 8px;
  font-size: 14px;

  &:active {
    transform: translateY(1px);
  }
}

>>> .el-dialog {
  border-radius: 20px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 10px;
}
</style>
